/* ======================================
   Abu Garcia VoltiQ LP - main.js
   ====================================== */

/* ---- Fade-in on scroll ---- */
document.addEventListener('DOMContentLoaded', function () {
  var targets = document.querySelectorAll('.fade-in:not(.lp-features__desc-wrap)');

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });

  targets.forEach(function (el) { observer.observe(el); });

  /* ---- アコーディオン：Safari対応（touchend + click 両対応） ---- */
  document.querySelectorAll('.lp-features__desc-toggle').forEach(function (btn) {
    function toggle(e) {
      e.preventDefault();
      e.stopPropagation();
      var wrap = btn.closest('.lp-features__desc-wrap');
      var isOpen = wrap.classList.contains('is-open');
      wrap.classList.toggle('is-open', !isOpen);
      btn.setAttribute('aria-expanded', String(!isOpen));
      btn.childNodes[0].textContent = isOpen ? '全て見る ' : '閉じる ';
      btn.querySelector('.lp-features__desc-toggle-icon').textContent = isOpen ? '∨' : '∧';
    }
    // touchend でタップ応答（Safari）
    btn.addEventListener('touchend', toggle, { passive: false });
    // click はtouchendの後に来るが、タップとして処理済みの場合はpreventDefaultで防ぐ
    btn.addEventListener('click', function (e) {
      // タッチデバイスではtouchendで処理済みなのでclickは無視
      if (e.detail === 0) return; // Safari: touchからのclickはdetail=0
      toggle(e);
    });
  });

  /* ---- 画像インジケーター ---- */
  document.querySelectorAll('.lp-features__images').forEach(function (track) {
    var indicator = track.nextElementSibling;
    if (!indicator || !indicator.classList.contains('lp-features__img-indicators')) return;
    var dots = indicator.querySelectorAll('.dot');
    if (!dots.length) return;

    track.addEventListener('scroll', function () {
      var scrollLeft = track.scrollLeft;
      var cardWidth = track.querySelector('.lp-features__img-card').offsetWidth + 16; // gap=16
      var idx = Math.round(scrollLeft / cardWidth);
      idx = Math.max(0, Math.min(idx, dots.length - 1));
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === idx);
      });
    }, { passive: true });
  });
});

/* ---- Slick Slider ---- */
$(function () {
  // 矢印はCSS :before で背景画像表示。imgタグは使わない
  var prevArrow = '<button type="button" class="slick-prev" aria-label="prev"></button>';
  var nextArrow = '<button type="button" class="slick-next" aria-label="next"></button>';

  var $slider = $('.lp-gallery__slider');

  $slider.slick({
    autoplay: true,
    autoplaySpeed: 4000,
    infinite: true,
    dots: false,
    centerMode: true,
    centerPadding: '20px',
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          prevArrow: prevArrow,
          nextArrow: nextArrow,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          arrows: true,
          prevArrow: prevArrow,
          nextArrow: nextArrow,
          centerMode: true,
          centerPadding: '30px',
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  /* ---- Fancybox Initialization ---- */
  Fancybox.bind('[data-fancybox]', {
    Toolbar: {
      display: {
        left: [],
        middle: [],
        right: ["close"]
      }
    },
    Thumbs: false,
    Carousel: {
      Navigation: false
    }
  });
});
